export const SEARCH_TRACKINGS = "SEARCH_TRACKINGS"
export const SEARCH_TRACKINGS_SUCCESS = "SEARCH_TRACKINGS_SUCCESS"
export const SEARCH_TRACKINGS_ERROR = "SEARCH_TRACKINGS_ERROR"
export const SEARCH_SAVE_KEYWORD = "SEARCH_SAVE_KEYWORD"

export const RESET_SEARCH_TRACKINGS_FLAG = "RESET_SEARCH_TRACKINGS_FLAG"